import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      subscription: {},
      account: {},
      total: {}
    },
    pagination: {}
  },

  getters: {
    currentSubscriptions: (state) => state.list,
    currentSubscription: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    subscriptionsFetched(state, { subscriptions }) {
      state.list = subscriptions
    },

    subscriptionFetched(state, { subscription }) {
      state.item = subscription
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchSubscriptions({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/subscriptions',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const subscriptions = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('subscriptionsFetched', { subscriptions })
      commit('paginationFetched', { pagination })
    },

    async fetchSubscription({ commit }, subscriptionId) {
      const response = await fetch({ url: `/api/admin/subscriptions/${subscriptionId}` })
      const subscription = await deserialize(response.data)

      commit('subscriptionFetched', { subscription })
    },

    async updateSubscription({ commit, state }, changes) {
      const response = await update({
        url: `/api/admin/subscriptions/${state.item.id}`,
        type: 'subscription',
        changes,
        record: state.item
      })
      const subscription = await deserialize(response.data)

      commit('subscriptionFetched', { subscription })
    }
  }
}
